import styled from 'styled-components';

export const ButtonStyled = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  cursor: pointer;
  border-radius: 3px;
  transition: 300ms;
  border: none;

  &:hover {
    opacity: 0.8;
    transition: 300ms;
  }

  & > span {
    font-family: var(--font-family);
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
  }
`;
